import React from "react";
import { Pagination } from "react-bootstrap";
import "./styles.scss";

/**
 *
 * @typedef {object} PaginacionProps
 * @property {"sm"|"md"|"lg"} size
 * @property {(page:number)=>void} setPage
 * @property {number} page
 * @property {number} pages
 *
 * @param {PaginacionProps} props
 * @returns
 */
const Paginacion = (props) => {
  const { size, setPage, pages, page } = props;
  const onClick = (pageNumber) => () => setPage(pageNumber);
  const nextPage = page === pages ? pages : page + 1;

  return (
    <Pagination className='paginacion' size={size}>
      <Pagination.Item onClick={onClick(1)}>Inicio</Pagination.Item>
      <Pagination.Item onClick={onClick(page - 1 || 1)}>Anterior</Pagination.Item>
      <Pagination.Item>
        {page} de {pages}
      </Pagination.Item>
      <Pagination.Item onClick={onClick(nextPage)}>Siguiente</Pagination.Item>
      <Pagination.Item onClick={onClick(pages)}>Final</Pagination.Item>
    </Pagination>
  );
};

export default Paginacion;
